import styled from 'styled-components'
import { useState } from 'react'
import moment from 'moment-timezone'
import { deviceType, customDate } from '../../../domain/data-model/form/utils'

import { Table } from 'reactstrap'
import VALUES from 'core/data-model/constants/values'

import { getIcon } from 'e-submission/components/Icon'
import { connect } from 'react-redux'

const DupTable = styled(Table)`
  text-align: center;
  width: 100%;

  .actionColumn {
    border-radius: 6px;
    width: 25%;
    box-shadow: 0 1px 2px 3px rgb(0 0 0 / 11%);
  }

  .column {
    display: flex;
    justify-content: space-around;
  }

  .firstColumn {
    text-align: right;
    width: 5%;
  }

  &.ekyc-mobile-layout {
    tbody th:first-child {
      width: 5.5rem;
      min-width: 5.5rem;
      max-width: 5.5rem;
      word-break: break-all;
      text-align: right;
      padding-right: 0.5rem;
      position: sticky;
      left: 0;
      z-index: 99;
      background-color: white;
    }

    td {
      text-align: left;
    }

    .slim {
      font-weight: normal;
      font-size: smaller;
    }
  }
`

const VerifiedColumn = styled.span`
  color: #1dc54e;
  font-weight: bold;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center vertically if needed */
  background-color: #f0f0f0; /* Light grey background */
  border-radius: 8px;
  &.mobile {
    padding-top: 1rem;
    max-height: 24rem;
  }

  &.web {
    padding: 1rem;
    overflow-x: scroll;
    max-height: 10rem;
  }
`

const ChoiceItem = styled.div`
   {
    padding: 1rem 0 0;
    display: flex;
  }
`
const ChoiceContainer = styled.div`
  padding: 1rem 0.5rem;

  &::before {
    content: '';
    display: block;
    border-top: solid 1px ${({ theme }) => theme.variables['$color-silver']};
    top: 1px;
    left: 1rem;
    right: 1rem;
  }

  .title {
    font-weight: bold;
  }

  .detail {
    padding-left: 0.5rem;
  }

  [type='radio'] {
    width: 20px;
    height: 20px;
    top: 5px;
    position: relative;
  }
`

const ScrollContainer = styled.div`
  overflow-x: scroll;

  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
`

const ExpandableIconDiv = styled.div`
  width: 16px;
  height: auto;
  cursor: pointer;
`

export const FirstCase = ({ cases, isShowHistories, toggle, handleClick, isChedked }) => {
  return (
    <tr>
      <td className="firstColumn">
        <ExpandableIconDiv onClick={() => toggle()}>
          {isShowHistories ? getIcon('arrowOutlineDown') : getIcon('arrowOutlineRight')}
        </ExpandableIconDiv>
      </td>
      <td>{cases.case.caseType.key}</td>
      <td>-</td>
      <td>{cases.firstName}</td>
      <td>{cases.lastName}</td>
      <td>{cases.citizenId}</td>
      <td>
        {moment(cases.expiresAt)
          .tz(VALUES.TIME_ZONE)
          .add(543, 'years')
          .format('DD MMM YYYY')}
      </td>
      <td className="bold">{cases.verificationCache.dopaConfig.required ? 'ต้องการ' : 'ไม่ต้องการ'}</td>
      <td>
        <div className="column">
          <div>
            <input
              type="radio"
              name="method-handle-dup-cases"
              id="new-case"
              checked={isChedked('new-case')}
              onChange={handleClick('new-case')}
            />
          </div>
          <div>
            <input
              type="radio"
              name="method-handle-dup-cases"
              id="reuse"
              checked={isChedked('reuse')}
              onChange={handleClick('reuse')}
            />
          </div>
        </div>
      </td>
    </tr>
  )
}
export const CaseItems = ({ cases }) => {
  return (
    <tr>
      <td className="firstColumn" />
      <td>{cases.case.caseType.key}</td>
      <td>-</td>
      <td>{cases.firstName}</td>
      <td>{cases.lastName}</td>
      <td>{cases.citizenId}</td>
      <td>
        {moment(cases.expiresAt)
          .tz(VALUES.TIME_ZONE)
          .add(543, 'years')
          .format('DD MMM YYYY')}
      </td>
      <td className="bold">{cases.verificationCache.dopaConfig.required ? 'ต้องการ' : 'ไม่ต้องการ'}</td>
      <td>
        {cases.verificationCache.verifiedAt ? (
          <VerifiedColumn>
            Verified ({customDate(cases.verificationCache.verifiedAt, 'DD/MM/YYYY hh:mm')})
          </VerifiedColumn>
        ) : (
          '-'
        )}
      </td>
    </tr>
  )
}

const Choice = ({ isChedked, handleClick }) => (
  <ChoiceContainer>
    <ChoiceItem>
      <input
        type="radio"
        name="method-handle-dup-cases"
        id="new-case"
        checked={isChedked('new-case')}
        onChange={handleClick('new-case')}
      />
      <div className="detail" style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="title"> สร้างลิงก์ใหม่ </span>
        <span>ส่งลิงก์ใหม่เพื่อให้ลูกค้ายืนยันตัวอีกครั้ง </span>
      </div>
    </ChoiceItem>
    <ChoiceItem>
      <input
        type="radio"
        name="method-handle-dup-cases"
        id="reuse"
        checked={isChedked('reuse')}
        onChange={handleClick('reuse')}
      />
      <div className="detail" style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="title"> ใช้ซ้ำ </span>
        <span>ใช้ผลการยืนยันตัวตนเดิมของลูกค้า </span>
      </div>
    </ChoiceItem>
  </ChoiceContainer>
)

const ExpandableDuplicateField = ({ cases, seletedOption, setOption }) => {
  const firstCase = cases[0]
  const isChedked = (optValue) => optValue === seletedOption
  const handleClick = (optValue) => () => {
    return setOption(optValue)
  }

  const [isShowHistories, setIsShowHistories] = useState(false)

  const setShowHistories = (value) => {
    setIsShowHistories(!isShowHistories)
  }

  return cases.length > 0 ? (
    <div>
      <Container className="web">
        <div>
          ชื่อจริง : <strong>{firstCase.firstName}</strong>
        </div>
        <div>
          นามสกุล : <strong>{firstCase.lastName}</strong>
        </div>
        <div>
          เลขกรมธรรม์ : <strong>{firstCase.case.policies[0].policyNumber}</strong>
        </div>
        <div>
          <div>eKYC Status:</div>
          <div style={{ paddingLeft: '1rem' }}>
            <div>
              Status ={' '}
              <strong>{firstCase.verificationCache?.status || firstCase.verificationCache?.ekycStatus || '-'}</strong>
            </div>
            <div>
              Date :{' '}
              <strong>
                {firstCase.verificationCache?.verifiedAt
                  ? customDate(firstCase.verificationCache.verifiedAt, 'DD/MM/YYYY')
                  : '-'}
              </strong>
            </div>
            <div>
              Time :{' '}
              <strong>
                {firstCase.verificationCache?.verifiedAt
                  ? customDate(firstCase.verificationCache.verifiedAt, 'HH:mm')
                  : '-'}
              </strong>
            </div>
          </div>
        </div>
      </Container>
      <Choice isChedked={isChedked} handleClick={handleClick} />
    </div>
  ) : null
}

const mapStateToProps = (state, props) => ({})
const mapDispatchToProps = (dispatch, { setShowHistories }) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ExpandableDuplicateField)
